import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/user/get/${id}`);
  },
  async getPanicAlert() {
    return await http.get(`/api/user/panic-alert`);
  },
  async getContactsStatus() {
    return await http.get(`/api/user/get-contacts-status`);
  },
  async insert(data) {
    return await http.post('/api/user/insert', data);
  },
  async update(data) {
    return await http.post('/api/user/update', data);
  },
  async delete(data) {
    return await http.post('/api/user/delete', data);
  }
};